module.exports = __webpack_public_path__ + "img/ug347.ee343004.png";